/* @flow */

import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';

//----------------------------------------------------------------------//
// MATERIAL UI                                                          //
//----------------------------------------------------------------------//

import Button from '@material-ui/core/Button';

//----------------------------------------------------------------------//
//----------------------------------------------------------------------//

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';

import styles from '../../../../ActionDrawer.module.scss';

type TypeProps = {
  currentAccountDetails: Object,
};

@translate()
@inject('actionDrawerStore')
@observer
export default class ExportAssetDataSuccess extends React.Component<*> {
  render(): React.Node {
    const actionDrawerStore: TypeActionDrawerStore = this.props.actionDrawerStore;
    const { currentAccountDetails, t }: TypeProps = this.props;

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <div>
            <h3>{t('general:success')}</h3>
            <h4>{t('general:trading_accounts.messages.disabled')}</h4>
          </div>
          <div className={styles['export-asset-data-details']}>
            <ul>
              <li>{currentAccountDetails.name}</li>
              <li>{currentAccountDetails.number}</li>
            </ul>
          </div>
        </div>
        <div className={styles['action-drawer-actions']}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => actionDrawerStore.closeActionDrawer()}
          >
            {t('general:actions.close')}
          </Button>
        </div>
      </React.Fragment>
    );
  }
}
